import { CHANNEL_DETAIL } from "../constants/action-types";

const initialState = {
  channel: {}
};
export default function channelDetailReducer(state = initialState, action) {
  switch (action.type) {
    case CHANNEL_DETAIL:
      return { ...action.payload };

    default:
      return state;
  }
}
